import React from 'react';
import classNames from 'classnames';
import type { CardProps } from './types';
import './card.scss';

export const Card: React.FC<CardProps> = ({ className, children, innerRef, ...props }) => (
  <div className={classNames('card-default', className)} ref={innerRef} {...props}>
    {children}
  </div>
);
